import React, { Component } from 'react';
import 'Styles/commonComponents/Table/Pagination.scss';
import IconsContainer from "Utils/IconsContainer";

export default class Pagination extends Component {
    constructor() {
        super();
        this.pageInputFocused = false;
        this.state = {
            pageInput: false
        }

        this.assignPaginationInfoContainer = this.assignPaginationInfoContainer.bind(this);
        this.assignPaginationInput = this.assignPaginationInput.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        document.addEventListener('mousedown', this.handleClickOutside);
    }

    GetPaginationInfo() {
        if (this.state.pageInput)
            return (
                <input
                    className='pagination-input'
                    onKeyPress={this.checkForEnterPress.bind(this)}
                    ref={this.assignPaginationInput} />
            );
        else
            return `${this.props.paginationInfo.currentPage} из ${this.props.paginationInfo.pageCount}`;
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate() {
        if (!this.state.pageInput || this.pageInputFocused) return;

        this.paginationInput.focus();
    }

    handleClickOutside(event) {
        if (this.paginationInfoContainer && !this.paginationInfoContainer.contains(event.target))
            this.closePaginationInput();
    }


    closePaginationInput() {
        this.setState({
            pageInput: false
        });

        this.pageInputFocused = false;
    }

    assignPaginationInfoContainer(container) {
        this.paginationInfoContainer = container;
    }

    assignPaginationInput(input) {
        this.paginationInput = input;
    }

    checkForEnterPress(e) {
        let allow_char = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
        if (allow_char.indexOf(e.which) === -1) {
            e.preventDefault();
        }

        if (e.charCode === 13) {
            if (this.paginationInput.value !== '') {
                if (isNaN(this.paginationInput.value)) {
                    e.preventDefault();
                    this.closePaginationInput();
                    return;
                } else if (parseInt(this.paginationInput.value) < 1)
                    this.paginationInput.value = '1';

                this.props.moves.concrete(+this.paginationInput.value);
            }
            this.closePaginationInput();
        }
    }

    render() {
        let { disableAll } = this.props;

        return (
            <div className={"pagination " + this.props.className}>
                <button className={"first-page " + (this.props.paginationInfo.firstPageEnabled && !disableAll ? '' : 'disabled')}
                    onClick={this.props.moves.first}>
                    <div className='change-page-button-icon-container'>
                        {IconsContainer.Get('ci-double-arrow-left')}
                    </div>
                </button>
                <button className={"prev-page " + (this.props.paginationInfo.prevPageEnabled && !disableAll ? '' : 'disabled')}
                    onClick={this.props.moves.prev}>
                    <div className='change-page-button-icon-container'>
                        {IconsContainer.Get('ci-arrow-down')}
                    </div>
                </button>
                <div className={"pagination-info " + (this.props.paginationInfo.pageCount > 1 && !disableAll ? '' : 'disabled')}
                    ref={this.assignPaginationInfoContainer}
                    onClick={_ => this.setState({ pageInput: true })}>
                    {this.GetPaginationInfo()}
                </div>
                <button className={"next-page " + (this.props.paginationInfo.nextPageEnabled && !disableAll ? '' : 'disabled')}
                    onClick={this.props.moves.next}>
                    <div className='change-page-button-icon-container'>
                        {IconsContainer.Get('ci-arrow-down')}
                    </div>
                </button>
                <button className={"last-page " + (this.props.paginationInfo.lastPageEnabled && !disableAll ? '' : 'disabled')}
                    onClick={this.props.moves.last}>
                    <div className='change-page-button-icon-container'>
                        {IconsContainer.Get('ci-double-arrow-left')}
                    </div>
                </button>
            </div>
        );
    }
}